import { v4 as uuid } from '@lukeed/uuid';
import { isbot } from 'isbot';
import Cookies from 'js-cookie';
export const USER_ID_STORAGE_KEY = 'uuid';
export const USER_ID_BOT = 'i-am-a-bot';
const TWO_YEARS = 730;
export const getCurrentUserId = () => {
    // Do not generate user id during SSR
    if (typeof window === 'undefined') {
        return '';
    }
    let id = Cookies.get('uuid');
    if (id) {
        // make sure to always renew the cookie
        Cookies.set(USER_ID_STORAGE_KEY, id, { expires: TWO_YEARS, path: '/' });
        return id;
    }
    try {
        id = window.localStorage.getItem(USER_ID_STORAGE_KEY);
    }
    catch {
        /* fail silently */
    }
    if (!id) {
        id = isbot(navigator.userAgent) ? USER_ID_BOT : uuid();
        try {
            window.localStorage.setItem(USER_ID_STORAGE_KEY, id);
        }
        catch {
            /* fail silently */
        }
    }
    Cookies.set(USER_ID_STORAGE_KEY, id, { expires: TWO_YEARS, path: '/' });
    return id;
};
//# sourceMappingURL=getCurrentUserId.js.map